const NUMBER_OPTIONS = {
  price: {
    eur: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'EUR',
    },
    usd: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'USD',
    },
  },
};

interface NumberFormatProps {
  locale?: string;
  options?: Intl.NumberFormatOptions;
  value: number | string;
}

const format = ({
  value,
  locale = window.__HB_LOCALE__ || 'en-US',
  options = {},
}: NumberFormatProps) => {
  const castedValue = Number(value);

  if (Number.isNaN(castedValue)) {
    throw new RangeError('[numberIntl:12] The value is not a number');
  }

  return new Intl.NumberFormat(locale, options).format(castedValue);
};

export { format, NUMBER_OPTIONS };
